var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.857,
    height: 22.857,
    viewBox: "0 0 22.857 22.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22346",
    "data-name": "Group 22346",
    transform: "translate(-1067.05 -372.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11581",
    "data-name": "Path 11581",
    d: "M22.476,22.1H20.953V9.524a.381.381,0,0,0-.381-.381H14.1V.381A.381.381,0,0,0,13.714,0H2.286A.381.381,0,0,0,1.9.381V22.1H.381a.381.381,0,0,0,0,.762h22.1a.381.381,0,0,0,0-.762M13.333,9.524V22.1H2.667V.762H13.333V9.524ZM20.191,22.1H14.1V9.9h6.1V22.1Z",
    transform: "translate(1067.05 372.143)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11582",
    "data-name": "Path 11582",
    d: "M94.248,54.249h2.286a.381.381,0,0,0,.381-.381V51.582a.381.381,0,0,0-.381-.381H94.248a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524H94.629Z",
    transform: "translate(977.374 323.227)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11583",
    "data-name": "Path 11583",
    d: "M196.648,54.249h2.286a.381.381,0,0,0,.381-.381V51.582a.381.381,0,0,0-.381-.381h-2.286a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524h-1.524Z",
    transform: "translate(879.545 323.227)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11584",
    "data-name": "Path 11584",
    d: "M94.248,156.649h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381H94.248a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524H94.629Z",
    transform: "translate(977.374 225.398)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11585",
    "data-name": "Path 11585",
    d: "M196.648,156.649h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381h-2.286a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524h-1.524Z",
    transform: "translate(879.545 225.398)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11586",
    "data-name": "Path 11586",
    d: "M94.248,259.049h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381H94.248a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524H94.629Z",
    transform: "translate(977.374 127.57)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11587",
    "data-name": "Path 11587",
    d: "M196.648,259.049h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381h-2.286a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524h-1.524Z",
    transform: "translate(879.545 127.57)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11588",
    "data-name": "Path 11588",
    d: "M94.248,361.449h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381H94.248a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524H94.629Z",
    transform: "translate(977.374 29.742)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11589",
    "data-name": "Path 11589",
    d: "M196.648,361.449h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381h-2.286a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524h-1.524Z",
    transform: "translate(879.545 29.742)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11590",
    "data-name": "Path 11590",
    d: "M350.248,259.049h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381h-2.286a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524h-1.524Z",
    transform: "translate(732.803 127.57)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11591",
    "data-name": "Path 11591",
    d: "M350.248,361.449h2.286a.381.381,0,0,0,.381-.381v-2.286a.381.381,0,0,0-.381-.381h-2.286a.381.381,0,0,0-.381.381v2.286a.381.381,0,0,0,.381.381m.381-2.286h1.524v1.524h-1.524Z",
    transform: "translate(732.803 29.742)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.f7eefa338f31bdd4e444bdd2a88a1496.svg";
export { ForwardRef as ReactComponent };